import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {update} from "../../../app/setters/update.js";

export const useCofnijTymczasoweOdblokuj = (setErrors) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch()

    return useMutation({
        mutationFn: (data) => update(`/oper/sprawozdanie/cofnij-tymczasowe-odblokuj`, data),
        onError: (err) => {
            if (typeof setErrors === 'function') {
                setErrors(err.response?.data?.errors);
            }
            toast.error(err.response?.data?.message || 'Błąd podczas operacji')
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0]?.startsWith?.('lista_sprawozdan'),
            });
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0]?.startsWith?.('czy_mozna_inicjowac'),
            });
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0]?.startsWith?.('lista_projektow'),
            });
        },
        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}

